import { CREATOR_ACTION_TYPES } from '../actions/types';

const initialState = {
  creator: null,
  loading: false,
  error: null,
  message: null
};

const creatorReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch creator actions
    case CREATOR_ACTION_TYPES.FETCH_CREATOR_REQUEST:
      return {
        ...state,
        // Keep existing creator visible during refresh to avoid profile header flicker
        loading: !state.creator,
        error: null,
        message: null
      };

    case CREATOR_ACTION_TYPES.FETCH_CREATOR_SUCCESS:
      return {
        ...state,
        loading: false,
        creator: action.payload.creator,
        message: action.payload.message,
        error: null
      };

    case CREATOR_ACTION_TYPES.FETCH_CREATOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        creator: null
      };

    // Update creator actions
    case CREATOR_ACTION_TYPES.UPDATE_CREATOR_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        message: null
      };

    case CREATOR_ACTION_TYPES.UPDATE_CREATOR_SUCCESS:
      return {
        ...state,
        loading: false,
        creator: action.payload.creator,
        message: action.payload.message,
        error: null
      };

    case CREATOR_ACTION_TYPES.UPDATE_CREATOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };

    // Delete creator actions
    case CREATOR_ACTION_TYPES.DELETE_CREATOR_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        message: null
      };

    case CREATOR_ACTION_TYPES.DELETE_CREATOR_SUCCESS:
      return {
        ...state,
        loading: false,
        creator: null,
        message: action.payload.message,
        error: null
      };

    case CREATOR_ACTION_TYPES.DELETE_CREATOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };

    // General creator actions
    case CREATOR_ACTION_TYPES.CLEAR_CREATOR_ERRORS:
      return {
        ...state,
        error: null,
        message: null
      };

    case CREATOR_ACTION_TYPES.SET_CREATOR_DATA:
      return {
        ...state,
        creator: action.payload.creator
      };

    default:
      return state;
  }
};

export default creatorReducer;
